export default __webpack_public_path__ + "static/media/wine-night.c7d2e74c.jpg";